import { render, staticRenderFns } from "./DeliverySimple.vue?vue&type=template&id=65c43016&scoped=true&"
import script from "./DeliverySimple.vue?vue&type=script&lang=js&"
export * from "./DeliverySimple.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySimple.vue?vue&type=style&index=0&id=65c43016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c43016",
  null
  
)

export default component.exports